import store from 'store'
// import _ from 'lodash'
import {PageType, EmployerType, SortType, ResType} from 'core/constant'
import {env, user, company, params, request} from 'bootsets/runtime'
import {HeadMenuItemsKey, HeadMenuItems} from 'core/view-constant'
const _isAdminViewStoreKey = `sets_${user.employerId}_isAdminView`

// 管理员导航 (角色是管理员, 并且当前视图是管理员视图)
const adminNavs = [{
    text: '设置',
    href: '/userInfo',
    pageType: PageType.COMPANY_SETTING
}, {
    text: '人员管理',
    href: '/company/user',
    pageType: PageType.COMPANY_USER
}, {
    text: '首页管理',
    href: '/company/publish',
    pageType: PageType.COMPANY_PUBLISH
// }, {
//     text: '百一商店',
//     href: `/store/open/resource?test101=1&resType=${ResType.QUESTION_BANK}`,
//     pageType: PageType.STORE_101TEST
}]

// 非企业版导航
// 1.功能型
const defaultNavs = [{
    text: '考试',
    href: '/paper',
    pageType: PageType.PAPER,
    userType: EmployerType.EXAMINER
}, {
    text: '题库',
    href: '/bank',
    pageType: PageType.BANK,
    userType: EmployerType.EXAMINER
}, {
    text: '群组',
    href: '/group',
    pageType: PageType.CLASS,
    userType: EmployerType.EXAMINER + EmployerType.EXAMINEE
}, {
    text: '成绩',
    href: '/my-test',
    pageType: PageType.SCORE,
    userType: EmployerType.EXAMINEE
}]

// 2.展示型
const navsForShow = [{
    text: '首页',
    href: '/',
    pageType: PageType.HOME,
    userType: EmployerType.EXAMINER + EmployerType.EXAMINEE
// }, {
//     text: '商店',
//     href: '/store/open/resource?sortType=' + SortType.LAST_UPDATE,
//     pageType: PageType.STORE,
//     userType: EmployerType.EXAMINER + EmployerType.EXAMINEE
// }, {
//     text: '社区',
//     href: 'http://bbs.101test.com',
//     target: '_blank',
//     userType: EmployerType.EXAMINER + EmployerType.EXAMINEE
}, {
    text: '服务说明',
    href: '/help/open/index',
    pageType: PageType.HELP,
    userType: EmployerType.EXAMINER + EmployerType.EXAMINEE
}]
// 企业版导航
const navsForCompany = [{
    text: '首页',
    href: '/',
    pageType: PageType.HOME,
    userType: EmployerType.EXAMINER + EmployerType.EXAMINEE
}, {
    text: '资源',
    href: '/store/open/resource?sortType=' + SortType.LAST_UPDATE,
    pageType: PageType.STORE,
    userType: EmployerType.EXAMINER + EmployerType.EXAMINEE
}, {
    text: '考试',
    href: '/paper',
    pageType: PageType.PAPER,
    userType: EmployerType.EXAMINER
}, {
    text: '题库',
    href: '/bank',
    pageType: PageType.BANK,
    userType: EmployerType.EXAMINER
}, {
    text: '群组',
    href: '/group',
    pageType: PageType.CLASS,
    userType: EmployerType.EXAMINER + EmployerType.EXAMINEE
}]

// 当前视图是否是管理员视图
const isAdminView = () => {
    // return Boolean(store.get(_isAdminViewStoreKey))
    return request.companyPath
}

/**
 * 切换至管理员视图
 */
const switch2AdminView = () => {
    store.set(_isAdminViewStoreKey, true)
}

/**
 * 切换至老师/学生视图
 */
const switch2NormalView = () => {
    store.set(_isAdminViewStoreKey, false)
}

/**
 * 解析企业版菜单字符串
 * 学生菜单keys|老师菜单keys, 如: dcf|abcd
 * @returns {*[]}
 * @private
 */
const _handleMenuStr = () => {
    // noinspection JSUnresolvedVariable
    const menuKeys = (company.contentObj.menuConfig || 'agdc|gbde').split('|')
    return [menuKeys[0] ? menuKeys[0].split('') : [], menuKeys[1] ? menuKeys[1].split('') : []]
}
/**
 *
 */
const _isShowType = () => {
    const currentType = +params.pageType || +request.pageType || ''
    return currentType === PageType.HOME ||
        currentType === PageType.STORE ||
        currentType === PageType.STORE_101TEST ||
        currentType === PageType.HELP ||
        window.showBlackBar
}

/**
 * 为学生菜单字符串数组加首页和成绩页
 * ['b'] -> ['a','b','c']
 * @param menuStrList
 * @private
 */
/* const _addHomeAndScore = (menuStrList) => {
    const _homeIndex = menuStrList.indexOf('a')
    const list = ['a', 'c', 'd', 'g']
    if (_homeIndex === -1) {
        menuStrList.unshift('a')
    }
    const _scoreIndex = menuStrList.indexOf('c')
    if (_scoreIndex === -1) {
        menuStrList.push('c')
    }
    for (let i in menuStrList) {
        if (list.indexOf(menuStrList[i]) === -1) {
            menuStrList.splice(i, 1)
        }
    }
    return menuStrList
}*/

/**
 * 为老师菜单字符串数组加考试和题库
 * ['g'] -> ['g','b','e']
 * @param menuStrList
 * @private
 */
/* const _addPaperAndBank = (menuStrList) => {
    const _paperIndex = menuStrList.indexOf('b')
    const list = ['b', 'd', 'e', 'g']
    if (_paperIndex === -1) {
        menuStrList.push('b')
    }

    const _bankIndex = menuStrList.indexOf('e')
    if (_bankIndex === -1) {
        menuStrList.push('e')
    }
    for (let i in menuStrList) {
        if (list.indexOf(menuStrList[i]) === -1) {
            menuStrList.splice(i, 1)
        }
    }
    return menuStrList
}*/

/**
 * 根据常量将菜单 keys -> 菜单data
 * @param menuKeys 例如:['a','b']
 * @returns {Array} 例如: [{...},{...}]
 * @private
 */
const _handleMenuKeys = (menuKeys) => {
    const _navs = []
    menuKeys.forEach((menuKey) => {
        const _menuName = HeadMenuItemsKey[menuKey]
        const _menuItem = HeadMenuItems[_menuName]
        if (_menuName && _menuItem) {
            _navs.push({
                text: _menuItem.tag,
                href: _menuItem.href,
                pageType: PageType[_menuName]
            })
        }
    })
    return _navs
}

/**
 * 根据用户信息, localstorage 中的当前视图状态, 当前域名是否是公司域名 等 获取顶部导航菜单信息
 * @returns {*}
 */
const getCurrentNavs = (role) => {
    let navs = []
    // 企业版域名; 按是否是管理员、当前视图（管理员视图/ 普通视图)、是否已登录显示不同的菜单
    if (env.isCompanyDomain) {
        const [examineeMenuKeys, examinerMenuKeys] = _handleMenuStr()
        // 企业版未登录
        if (!user.login) {
            navs = navsForCompany
        } else {
            // 管理员视图
            if (user.isCompanyAdmin && isAdminView()) {
                navs = adminNavs
            } else {
                // 企业版普通用户/ 企业版管理员用户非管理员视图
                navs = ((role || user.employerType) === EmployerType.EXAMINEE)
                    ? _handleMenuKeys(examineeMenuKeys)
                    : _handleMenuKeys(examinerMenuKeys)
            }
        }
    } else {
        // 普通版域名, 按登录状态、用户角色显示不同的菜单
        if (!user.login) {
            navs = navsForShow
        } else {
            if (_isShowType()) {
                navs = navsForShow
            } else {
                defaultNavs.forEach((_nav) => {
                    if (user.employerType & _nav.userType) {
                        navs.push(_nav)
                    }
                })
            }
        }
    }
    return navs
}

/**
 * @returns {*}
 */
const getFirstPage = (role) => {
    let navs = []
    defaultNavs.forEach((_nav) => {
        if (user.employerType & _nav.userType) {
            navs.push(_nav)
        }
    })
    return navs[0].href
}
export {
    isAdminView,
    switch2AdminView,
    switch2NormalView,
    getCurrentNavs,
    getFirstPage
}


// WEBPACK FOOTER //
// ./app/scaffold/navbar-util.js